import { useAppointmentModal } from "@/contexts/AppointmentModalContext";
import { useQuery } from "@tanstack/react-query";
import type { AppointmentRecord } from "@/lib/types/appointment";
import { fetchAppointmentDetails } from "@/lib/services/appointmentModalService";

/**
 * Hook to get full appointment details for the current appointment in the modal context.
 * Returns the React Query result for appointment details.
 */
export function useAppointmentModalDetailsInfo() {
  const { appointmentId } = useAppointmentModal();
  return useQuery<AppointmentRecord | null>({
    queryKey: ["appointmentDetails", appointmentId],
    queryFn: () => fetchAppointmentDetails(appointmentId ?? 0),
    enabled: !!appointmentId,
    staleTime: 60_000, // was 0; edits invalidate the key precisely (doc 07 Phase B)
    gcTime: 0,
    refetchOnMount: 'always',
    retry: 0,
  });
}
